<template>
  <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
    <el-row :gutter="20" class="h-full">
      <el-col :span="6" class="border-r-1 border-color-[#E0E0E0] h-full">
        <div>
          <span class="border-l-3 border-color-primary pl-10px text-18px">数据标准库</span>
        </div>
        <div class="mt-10px">
          数据标准库：<selectStandardId @updateStandardId="updateStandardId"></selectStandardId>
        </div>
        <div class="mt-10px">
          <span class="border-l-3 border-color-primary pl-10px text-18px">实体选择</span>
        </div>
        <div class="flex mt-10px">
          <el-input
            v-model="keyword"
            placeholder="实体名称/实体表名"
            size="small"
            clearable
            class="mr-10px"
          ></el-input>
          <el-button type="primary" size="small">搜索</el-button>
          <el-button type="primary" size="small">添加</el-button>
        </div>
        <div class="mt-10px h-[calc(100%-160px)] text-14px">
          <div class="mb-10px">全部(66)</div>
          <div class="h-[calc(100%-24px)] pl-10px classData">
            <div v-for="(item, index) in classData" :key="index">
              <div class="mb-5px">
                <el-checkbox v-model="item.checked" @change="checkAll(item)"></el-checkbox
                >{{ item.name }}({{ item.count }})
              </div>
              <div v-if="item.classList && item.classList.length" class="pl-10px">
                <el-row :gutter="10" class="border-b-1 border-color-[#bbbbbb] pb-5px">
                  <el-col :span="8">实体名称</el-col>
                  <el-col :span="8">实体表名</el-col>
                  <el-col :span="8">来源系统</el-col>
                </el-row>
                <el-row
                  :gutter="10"
                  v-for="(cItem, cIndex) in item.classList"
                  :key="cIndex"
                  class="mt-5px text-[#bdbfbf]"
                >
                  <el-col :span="8" class="truncate"
                    ><el-checkbox v-model="cItem.checked" @change="checkOne(cItem)"></el-checkbox
                    >{{ cItem.name }}</el-col
                  >
                  <el-col :span="8" class="truncate">{{ cItem.tableName }}</el-col>
                  <el-col :span="8" class="truncate">{{ cItem.source }}</el-col>
                </el-row>
              </div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="18" class="h-full">
        <div class="flex justify-end mb-20px">
          <el-button type="primary">预览</el-button>
          <el-button type="primary">模板设计</el-button>
          <el-button type="primary">上传模板</el-button>
          <el-button type="primary">预览</el-button>
        </div>
        <el-table
          :data="tableData"
          v-loading="tableLoading"
          border
          height="calc(100% - 108px)"
          :highlight-current-row="true"
          @selection-change="selectionChange"
          ref="multipleTable"
          stripe
          row-key="id"
        >
          <el-table-column type="selection" :reserve-selection="true" width="55"></el-table-column>
          <el-table-column label="实体名称" prop="name" show-overflow-tooltip> </el-table-column>
          <el-table-column label="实体表名" prop="name" show-overflow-tooltip> </el-table-column>
          <el-table-column label="来源系统" prop="name" show-overflow-tooltip> </el-table-column>
          <el-table-column label="特殊表头" width="250" fixed="right">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.checked"></el-switch>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="page.pageNo"
          :page-sizes="$pageSizeAll"
          :page-size.sync="page.pageSize"
          layout="->, total, sizes, prev, pager, next, jumper"
          :total="page.total"
          class="mt-20px"
        ></el-pagination>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import selectStandardId from '../../components/selectStandardId'

export default {
  name: 'objectCollectionConfig',
  components: { selectStandardId },
  data() {
    return {
      standardId: localStorage.getItem('standardId'),
      keyword: '',
      defaultProps: {
        label: 'name',
        children: 'children',
      },
      classData: [
        {
          name: '逻辑设备',
          count: 3,
          checked: false,
          classList: [
            {
              name: '电厂',
              tableName: 'ODS FALCITY',
              source: 'EAM',
              checked: false,
            },
            {
              name: '机组',
              tableName: 'ODS FALCITY',
              source: 'EAM',
              checked: false,
            },
            {
              name: '系统',
              tableName: 'ODS FALCITY',
              source: 'EAM',
              checked: false,
            },
          ],
        },
      ],
      tableData: [],
      tableLoading: false,
      selectList: [],
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
    }
  },
  methods: {
    updateStandardId(val) {
      this.standardId = val
    },
    handleNodeClick() {},
    checkAll(item) {
      _.map(item.classList, (it) => {
        it.checked = item.checked
        return item
      })
    },
    checkOne(cItem) {
      console.log(cItem)
    },
    selectionChange(val) {
      this.selectList = val
    },
    handleSizeChange(size) {
      this.page.pageSize = size
    },
    handleCurrentChange(num) {
      this.page.pageNo = num
    },
  },
}
</script>
